import { Navigate, useParams } from "react-router";

import { useScopedHref } from "@/hooks";

export const LeaguePageRedirect = () => {
  const { id } = useParams();
  const scopedHref = useScopedHref();
  return <Navigate to={scopedHref(`/league/${id}/overview`)} replace={true} />;
};
